<div class="modal-header {{notificationClass}} close_btn_align notifyModelHead">
    <div class="allNotifyBlock">
        <!-- <button type="button" class="btn-close" style="font-size: 10px;float: right;" data-bs-dismiss="modal" (click)="closeModal()"></button> -->
        <label class="notificationMessage">{{Message}}</label>
    </div>
  </div>